import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import SAR from "@componentsShared/SAR/SAR";
import CreditCardInfoShimmer from "@/pages/checkout/CheckoutV2/components/CreditCardInfoShimmer";
import { useTranslation } from "@i18n";
import usePaymentHook from "@/pages/checkout/CheckoutV2/hooks/usePaymentHook";
import { api__createAribPaymentSessionValidation } from "@/apis/checkout/createSession";
import useHelpers from "@hooks/useHelpers";
import { toast } from "sonner";
import "../../../../pages/module-sell-trade/components/MoyasarSellTradeStyleOverRide.css";
var PaymentFormComponent = function PaymentFormComponent(_ref) {
  var _checkoutOrder$paymen;
  var session = _ref.session,
    checkoutOrder = _ref.checkoutOrder,
    post_id = _ref.post_id,
    paymentProcessingUrl = _ref.paymentProcessingUrl;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var on_initiating = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return api__createAribPaymentSessionValidation({
              order_id: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id,
              paymentProcessingUrl: paymentProcessingUrl
            })["catch"](function (e) {
              if (e.trace) {
                toast.error(e.trace);
              } else {
                toast.error(e.message);
              }
              return false; // Return false to stop payment
            });
          case 1:
            return _context.a(2, _context.v);
        }
      }, _callee);
    }));
    return function on_initiating() {
      return _ref2.apply(this, arguments);
    };
  }();
  var on_completed = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            return _context2.a(2, navigateTo("/finance-apply-arib?post_id=".concat(post_id)));
        }
      }, _callee2);
    }));
    return function on_completed() {
      return _ref3.apply(this, arguments);
    };
  }();
  usePaymentHook({
    divSelector: '.mysr-form',
    paymentSession: session.paymentSession,
    gatewayType: session.gateway_type,
    events: {
      on_initiating: on_initiating,
      on_completed: on_completed
    },
    template: {
      payButtonText: t("pay", {
        ns: "web_checkout_cash"
      })
    },
    internvalTimeoutSeconds: 10
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "px-4 lg:px-0 pt-6 lg:pt-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-[24px] font-bold text-primary break-all flex items-center gap-0.5 flex-wrap gap-y-2"
  }, /*#__PURE__*/React.createElement("span", null, tShort("arib/payment_main_title", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-success"
  }, tShort("arib/payment_sub_title", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "text-start text-base text-gray-causeway font-medium"
  }, tShort("arib/payment_description", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-success-90 border-solid rounded p-2 flex justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/safety-outlined.svg",
    alt: "saftey"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-neutral-50 text-sm font-medium"
  }, tShort("arib/disclaimer_1_title", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/sima.svg",
    alt: "sima"
  })), /*#__PURE__*/React.createElement("div", {
    className: "border border-[#ACB8C8] border-solid rounded p-3 flex justify-between overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-neutral-90 text-sm font-bold"
  }, tShort("arib/disclaimer_2_title", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-gray-causeway font-medium text-sm"
  }, tShort("arib/disclaimer_2_subtitle", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-base font-bold"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$paymen = checkoutOrder.payment_info) === null || _checkoutOrder$paymen === void 0 ? void 0 : _checkoutOrder$paymen.display_amount), /*#__PURE__*/React.createElement(SAR, {
    className: "text-primary"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "mt-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mysr-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement(CreditCardInfoShimmer, null))))));
};
export default PaymentFormComponent;